const getters = {
  sidebar: state => state.sidebar,
  menu: state => state.menu,
  identity: state => state.identity,
  config: state => state.config,
  helperDoc: state => state.helperDoc
}
export default getters
